// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1LMNV","head":"Table_head__1VgtP","col":"Table_col__2YSJc"};